import {
  http,
} from "./http.js";

async function getImages(resource, id) {
  const response = await http.get(`${resource}/${id}/images`);
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        id: i.Id,
        originName: i.OriginName,
        path: i.Path,
      };
    });
  } else {
    return [];
  }
}

async function downloadImage(resource, id) {
  const response = await http.get(`${resource}/images/${id}/download`, {
    headers: { Accept: "application/x-binary" },
  });
  return response;
}

async function uploadImage(resource, id, images) {
  const response = await http.post(`${resource}/${id}/images`, images);
  return response;
}

async function deleteImage(resource, id, imageId) {
  const response = await http.delete(`${resource}/${id}/image/${imageId}`);
  return response;
}

export {
  getImages,
  downloadImage,
  uploadImage,
  deleteImage,
};